<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
/* 表格单元格强制单行省略，避免长内容换行撑高行高。
   说明：Element 的 show-overflow-tooltip 是列级属性，写在 <el-table> 上无效，
   故用全局样式统一处理单行省略；若某列需要悬浮查看全文，再在该 <el-table-column> 上加 show-overflow-tooltip。 */
.el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

/* 搜索表单（内联）紧凑：缩小表单项下边距（Element 默认 22px） */
.demo-form-inline .el-form-item {
  margin-bottom: 8px;
}
</style>
